export const REQUEST_CASE_DATA_OF_CASE_LOOKUP = 'REQUEST_CASE_DATA_OF_CASE_LOOKUP';
export const RECEIVE_CASE_DATA_OF_CASE_LOOKUP = 'RECEIVE_CASE_DATA_OF_CASE_LOOKUP';

export const UPDATE_FILTERS_OF_CASE_DATA_OF_CASE_LOOKUP = 'UPDATE_FILTERS_OF_CASE_DATA_OF_CASE_LOOKUP';

export const CLEAR_ALL_FILTERS_OF_CASE_LOOKUP = 'CLEAR_ALL_FILTERS_OF_CASE_LOOKUP';


/** WEBPACK FOOTER **
 ** ./src/constants/caseLookupConstants.js
 **/